/**
 * Price pop-in.
 *
 * Focal's <product-meta> rewrites the price on every `variant:changed`, and a
 * multi-currency app re-formats the value inside `<span class="money">`. We must
 * NOT restructure that value (splitting it into per-character spans corrupts the
 * currency app's parsing). Instead, when the displayed price actually changes,
 * we replay a single pop-in animation on the whole price element.
 *
 * It never touches the initial server-rendered price, so the LCP price paints
 * instantly at full opacity with no animation or layout shift.
 */
(function () {
  'use strict';

  var PRICE_LIST_SELECTOR = '[data-product-price-list]';
  // Main price only (not the strikethrough compare price or unit price).
  var MAIN_PRICE_SELECTOR = '.price--large';
  var POP_CLASS = 'price-pop';

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function currentPriceText(container) {
    var priceEl = container.querySelector(MAIN_PRICE_SELECTOR);
    return priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function pop(priceEl) {
    priceEl.classList.remove(POP_CLASS);
    // Force a reflow so removing + re-adding the class restarts the animation.
    void priceEl.offsetWidth;
    priceEl.classList.add(POP_CLASS);

    var styles = getComputedStyle(priceEl);
    var dur = parseFloat(styles.getPropertyValue('--price-pop-dur')) || 300;
    setTimeout(function () {
      priceEl.classList.remove(POP_CLASS);
    }, dur + 80);
  }

  function observe(container) {
    if (reduceMotion || container.__pricePopBound) return;
    container.__pricePopBound = true;

    // Seed with the initial price so the first variant change is what triggers
    // the animation (never the initial paint).
    container.__lastPrice = currentPriceText(container);

    var observer = new MutationObserver(function () {
      var text = currentPriceText(container);
      if (!text || text === container.__lastPrice) return;
      container.__lastPrice = text;

      var priceEl = container.querySelector(MAIN_PRICE_SELECTOR);
      if (priceEl) pop(priceEl);
    });

    // Toggling our own class is an attribute change, which we deliberately do
    // NOT observe, so the animation can never re-trigger itself.
    observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    var lists = document.querySelectorAll(PRICE_LIST_SELECTOR);
    for (var i = 0; i < lists.length; i++) observe(lists[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-bind when a section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
